import { CoDocumentodetalle } from './../../../comercial/codocumento/dominio/CoDocumentodetalle';
import { CoCotizacion } from './../../../comercial/cotizacion/dominio/CoCotizacion';
import { CoDocumento } from 'src/app/erp/comercial/codocumento/dominio/CoDocumento';
import { DtoWhItemList } from './../dominio/DtoWhItemList';
import { FiltroWhItemMast } from './../dominio/FiltroWhItemMast';
import { Injectable, Inject } from '@angular/core';
import { AppConfig } from 'src/environments/appconfig';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';
import { DtoWhItemmast } from '../dominio/DtoWhItemmast';

@Injectable()
export class WhItemMastServicio {

    private url = `${this.config.getEnv('proxy')}spring/logistica/whitemmast/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarItemPaginacion(filtro: FiltroWhItemMast): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarItemPaginacion`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }

    public listarItemPaginacionAlmacenes(filtro: FiltroWhItemMast): Promise<DtoWhItemmast[]> {
        return this.http.post(`${this.url}listarItemPaginacionAlmacenes`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoWhItemmast[];
            })
            .catch(error => []);
    }

    public obtenerItem(itemCodigo: string): Promise<DtoWhItemList> {
        return this.http.get(`${this.url}openedWhitem/` + itemCodigo,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoWhItemList;
            })
            .catch(error => new DtoWhItemList);
    }

    calcularMontos(coDocumento: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}calcularMontos`, coDocumento,{headers: this.headers}
        )
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

    descuentosEditar(coDocumentodetalle: CoDocumentodetalle): Promise<CoDocumentodetalle> {
        return this.http.post(`${this.url}descuentosEditar`, coDocumentodetalle,{headers: this.headers}
        )
            .toPromise()
            .then(response => {
                return response as CoDocumentodetalle;
            })
            .catch(error => null);
    }


    calcularMontosCotizacion(coDocumento: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}calcularMontosCotizacion`, coDocumento,{headers: this.headers}
        )
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }
    public listarItems(item: string): Promise<DtoWhItemList[]> {
        const params = new HttpParams()
            .set('item', JSON.stringify(item));

        return this.http.get(`${this.url}listarItems`, { params,headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoWhItemList[];
            })
            .catch(error => new Array());
    }
}

